import { Injectable, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { AdaptiveLayoutFlag, AdaptiveLayoutProvider } from './adaptive-layout.service';
import { ColumnLayoutService } from './column-layout.service';

@Injectable({ providedIn: 'root' })
export class RightColumnLayoutProvider implements AdaptiveLayoutProvider {
    private columnLayoutService = inject(ColumnLayoutService);

    asObservable(): Observable<AdaptiveLayoutFlag> {
        return this.columnLayoutService.rightColumnSizeChanged.pipe(map((column) => ({ rightColumnSize: column.size })));
    }
}
